export const round = (value: number, decimals = 0) =>
    Number((Math.round((value + Number.EPSILON) * 100) / 100).toFixed(decimals));

export const toCents = (value: number) => round(value * 100);
